import { render } from "./Downloader.vue?vue&type=template&id=4d0e5690&scoped=true"
import script from "./Downloader.vue?vue&type=script&lang=js"
export * from "./Downloader.vue?vue&type=script&lang=js"

import "./Downloader.vue?vue&type=style&index=0&id=4d0e5690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0e5690"]])

export default __exports__